export const CART_ENDPOINTS = {
  createTempBooking: "/api/Common/CreateTempBooking",
  getTempBooking: "/api/Common/GetTempBooking",
};
